"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchpadAPI = void 0;
var launchpad_constants_1 = require("./launchpad.constants");
var api_client_1 = __importStar(require("../api-client"));
var api_utils_1 = require("../../utils/api.utils");
var UPLOAD_HOST = process.env.NEXT_PUBLIC_UPLOAD_HOST || '';
var LaunchpadAPI = /** @class */ (function () {
    function LaunchpadAPI() {
    }
    LaunchpadAPI.create = function (data) {
        return api_client_1.default.post(launchpad_constants_1.LAUNCHPAD_API_URLS.CREATE, data);
    };
    LaunchpadAPI.update = function (data) {
        return api_client_1.default.post(launchpad_constants_1.LAUNCHPAD_API_URLS.UPDATE, data);
    };
    LaunchpadAPI.getByFilter = function (data, headers) {
        return api_client_1.default.post(launchpad_constants_1.LAUNCHPAD_API_URLS.GET_BY_FILTER, data, { headers: headers });
    };
    LaunchpadAPI.fetchById = function (id, headers) {
        return api_client_1.default.post(launchpad_constants_1.LAUNCHPAD_API_URLS.GET_BY_ID, { id: id }, { headers: headers });
    };
    LaunchpadAPI.removeBanner = function (id) {
        return api_client_1.default.post(launchpad_constants_1.LAUNCHPAD_API_URLS.REMOVE_BANNER, { id: id });
    };
    LaunchpadAPI.bulkUploadNfts = function (id, file, config) {
        var url = "/v2/launchpad/".concat(id, "/upload-nfts");
        var formData = new FormData();
        formData.append('file', file);
        var hostname = window.location.hostname;
        if (!(0, api_utils_1.isLocalhost)(hostname)) {
            url = "".concat(UPLOAD_HOST).concat(api_client_1.BASE_NAME).concat(url);
        }
        return api_client_1.default.post(url, formData, config || {});
    };
    return LaunchpadAPI;
}());
exports.LaunchpadAPI = LaunchpadAPI;
